<template>
  <div class="container">
    <div
      class="mySlides"
      v-for="(slide, index) in slides"
      :key="index"
      :style="{ display: slideIndex === index + 1 ? 'block' : 'none' }"
    >
      <div class="numbertext">{{ index + 1 }} / {{ slides.length }}</div>
      <img :src="slide" style="width:100%" />
    </div>

    <div v-if="slides.length > 1">
      <a class="prev" @click="plusSlides(-1)">❮</a>
      <a class="next" @click="plusSlides(1)">❯</a>

      <div class="caption-container">
        <p id="caption">List Images</p>
      </div>

      <div class="row">
        <div class="column" v-for="(slide, index) in slides" :key="'thumb-' + index">
          <img
            class="demo cursor"
            :src="slide"
            style="width:100%; height: 150px; padding: 0 3px"
            @click="currentSlide(index + 1)"
            :class="{ active: slideIndex === index + 1 }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      slideIndex: 1,
    }
  },
  methods: {
    plusSlides(n) {
      this.slideIndex += n
      if (this.slideIndex > this.slides.length) this.slideIndex = 1
      if (this.slideIndex < 1) this.slideIndex = this.slides.length
    },
    currentSlide(n) {
      this.slideIndex = n
    }
  }
}
</script>

<style scoped>
img {
  vertical-align: middle;
}

.container {
  position: relative;
}

.mySlides {
  display: none;
}

.cursor {
  cursor: pointer;
}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 40%;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  user-select: none;
}

.next {
  right: 0;
}

.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

.caption-container {
  text-align: center;
  background-color: #222;
  padding: 2px 16px;
  margin: 5px 0;
  color: white;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

.column {
  float: left;
  width: 16.66%;
}

.demo {
  opacity: 0.6;
  transition: opacity 0.3s;
}

.active,
.demo:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// SliderClaimImages.vue?191f951e